import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 15v-3.5a2.5 2.5 0 1 1 5 0v3.5m0 -2h-5","key":"svg-0"}],["path",{"d":"M3 9l3 6l3 -6","key":"svg-1"}],["path",{"d":"M9 20l6 -16","key":"svg-2"}]]

const IconKerning = createReactComponent('outline', 'kerning', 'Kerning', __iconNode);

export default IconKerning;